/**
 * Menü şekli ve açılış sayfası (katalog s. 7 ve 18).
 *
 *   Müşteri         : AI · Overview · Financial Results · Proposed Solutions ·
 *                     My Accountant | Account: Membership · Settings · Global
 *   Ofis sahibi/yön.: AI · Clients · Inbox · Missing documents · Month close |
 *                     Firm: Team · Membership · Settings · Global
 *   Personel        : AI · My clients · Inbox · Missing documents · Month close |
 *                     Account: Settings · Global
 *
 * Açılış: müşteri AI sayfası, ofis Clients.
 *
 * Menüyü gizlemek GÜVENLİK DEĞİLDİR: kimin hangi satırı okuyacağına her
 * istekte veritabanı karar verir (katalog s. 18).
 */

import { defineFeature } from '../../shell/feature.ts';
import { legacy } from '../../shell/bridge.ts';

type Side = 'customer' | 'owner' | 'manager' | 'staff';

interface FirmContext { firm_owner_id: string | null; role: string | null; firm_name: string | null }

let side: Side | null = null;
let context: FirmContext | null = null;

function el(id: string): HTMLElement | null { return document.getElementById(id); }

const MENUS: Record<Side, string[]> = {
  customer: ['ni6', 'ni0', 'ni1', 'ni2', 'ni10', 'ni7', 'ni4', 'ni3'],
  owner:    ['ni6', 'ni12', 'ni13', 'ni14', 'ni15', 'ni11', 'ni7', 'ni4', 'ni3'],
  manager:  ['ni6', 'ni12', 'ni13', 'ni14', 'ni15', 'ni11', 'ni7', 'ni4', 'ni3'],
  staff:    ['ni6', 'ni12', 'ni13', 'ni14', 'ni15', 'ni4', 'ni3'],
};
const ALL = ['ni6', 'ni0', 'ni1', 'ni2', 'ni10', 'ni12', 'ni13', 'ni14', 'ni15', 'ni11', 'ni7', 'ni4', 'ni3'];

function isCustomer(): boolean {
  const g = globalThis as unknown as { atIsCustomer?: () => boolean };
  return typeof g.atIsCustomer === 'function' ? g.atIsCustomer() : false;
}

async function loadContext(): Promise<FirmContext | null> {
  const sb = legacy.sb;
  if (!sb) return null;
  try {
    const r = await sb.rpc('my_firm_context');
    return r && !r.error ? (r.data as FirmContext) : null;
  } catch { return null; }
}

function badge(id: string, n: number): void {
  const b = el(id);
  if (!b) return;
  b.textContent = String(n);
  b.style.display = n > 0 ? '' : 'none';
}

function paint(): void {
  if (!side) return;
  const show = new Set(MENUS[side]);
  for (const id of ALL) {
    const n = el(id);
    if (n) n.style.display = show.has(id) ? '' : 'none';
  }
  const sec = el('sb-sec2-lbl');
  if (sec) sec.textContent = side === 'owner' || side === 'manager' ? 'Firm' : 'Account';
  const clients = el('nav-clients');
  if (clients) clients.textContent = side === 'staff' ? 'My clients' : 'Clients';
}

/** Rozet sayıları: ofiste müşteri/gelen/eksik, müşteride son 7 günün değişikliği. */
async function refreshBadges(): Promise<void> {
  const sb = legacy.sb;
  if (!sb || !side) return;
  try {
    if (side === 'customer') {
      const r = await sb.rpc('my_accountant');
      const changes = (r && r.data && Array.isArray(r.data.changes)) ? r.data.changes as Array<{ written_at: string }> : [];
      const week = Date.now() - 7 * 864e5;
      badge('nb-acc', changes.filter((c) => new Date(c.written_at).getTime() > week).length);
    } else {
      const r = await sb.rpc('firm_clients_overview');
      const s = r && r.data && r.data.summary;
      if (s) {
        badge('nb-clients', Number(s.total) || 0);
        badge('nb-inbox', Number(s.inbox) || 0);
        badge('nb-missing', Number(s.missing) || 0);
      }
    }
  } catch { /* rozet yoksa menü yine çalışır */ }
}

async function apply(): Promise<void> {
  if (isCustomer()) {
    side = 'customer';
    context = null;
  } else {
    context = await loadContext();
    const role = context?.role;
    side = role === 'manager' || role === 'staff' ? role : 'owner';
  }
  paint();
  void refreshBadges();
}

function landing(): void {
  const g = globalThis as unknown as { aipOpenAssistant?: () => void; fwNav?: (m: string) => void };
  if (isCustomer() || typeof g.fwNav !== 'function') {
    g.aipOpenAssistant?.();
    return;
  }
  g.fwNav('clients');
}

export default defineFeature({
  id: 'nav-shape',
  label: 'Menü şekli ve açılış sayfası',
  view: null,

  legacyGlobals: {
    navApply: () => apply(),
    navLanding: () => landing(),
    navRefreshBadges: () => refreshBadges(),
    navSide: () => side,
    navFirmContext: () => context,
  },
});
